module.exports = __webpack_public_path__ + "static/media/p1.508557af.png";